<ng-container *transloco="let t">
  <app-dialog-wrap [data]="data">
    <mat-dialog-content>
      @if (data.isPrivacy) {
        <app-testo-privacy
        ></app-testo-privacy>
      } @else {
        <app-testo-termini-e-condizioni></app-testo-termini-e-condizioni>
      }

    </mat-dialog-content>


  </app-dialog-wrap>

  <div class="w-full pb-8 pr-6">
      <div class="mt-0.5 mb-0.5 flex flex-row items-center justify-end">
      <button [color]="'primary'" mat-raised-button (click)="closeDialog()">{{t('common.close')}}</button>
    </div>
  </div>
</ng-container>
